import { AdvertisingOption } from 'owa-advertising-option';
import { OptionSubCategory } from 'owa-options-core';

let advertisingSubCategory: OptionSubCategory = {
    key: 'advertising',
    titleStringKey: 'optionSubcategory_ads',
    options: [AdvertisingOption],
};

export default advertisingSubCategory;
